export const ConnectionStatusType = {
  Connecting: 'connecting',
  Disconnected: 'disconnected',
  Connected: 'connected',
};
export type ConnectionStatusType =
  (typeof ConnectionStatusType)[keyof typeof ConnectionStatusType];
